import { createRef } from 'react'
import filesService from '../services/filesService';
import { Link } from '@mui/material';
import { useSnackbar } from 'notistack';

export function AuthenticatedLink ({ url, children }) {
  const { enqueueSnackbar } = useSnackbar();

  const linkStyle = {
      cursor: 'pointer'
  };

  const link = createRef();

  const getFileName = (fullPath) => {
    const searchTerm = 'fileName=';
    const searchIndex = fullPath.indexOf(searchTerm);
    const fileName = fullPath.substr(searchIndex + searchTerm.length);
    //const fileNameExtension = fileName.split('.').pop();
    //return 'Счет.' + fileNameExtension;
    return fileName;
  }
  
  const handleAction = async () => {
    if (link.current.href) { return }
  
    const result = await filesService.getFile(url)
      .catch((error) => {
        enqueueSnackbar(`Не удалось скачать файл`, { variant: "error" });
      });
    
    if (result)
    {
        const blob = await result.blob();
        const href = window.URL.createObjectURL(blob);
        
        link.current.download = getFileName(url);
        link.current.href = href;
        link.current.style.cursor = 'pointer';
        
        link.current.click();
    }
  }

  return (
    <>
      <Link ref={link} onClick={handleAction} sx={{ mr:0.5, ml:0.5 }} style={linkStyle} color="inherit" underline="none" variant="inherit">{children}</Link>
    </>
  )
}